/*
 * @Descripttion: FormList
 * @Author: 郑泳健
 * @Date: 2023-03-06 18:42:08
 * @LastEditors: 郑泳健
 * @LastEditTime: 2023-04-06 17:42:31
 */

import React, { useState, useEffect, useRef, useContext, memo } from 'react'
import { cloneDeep, isEqual } from 'lodash'
import { getNames } from '../utils'
import { FormContext } from '../store'
import type { IFormListProps, IFormContext, ILevel, TAddOrRemove, IObject } from '../interface'

const List: React.FC<IFormListProps> = ({ name, children }) => {
  const maxRef = useRef(-1)
  const { form, initialValues, compsRefs, updateRefs } = useContext<IFormContext>(FormContext)
  const [dataLevel, setDataLevel] = useState<ILevel[]>([])

  /** 根据一开始记录的渲染shouldUpdate 和 dependencies组件 */
  const updateRender = () => {
    if (Array.isArray(updateRefs.current.shouldUpdateList)) {
      updateRefs.current.shouldUpdateList.forEach((i) => {
        compsRefs?.current?.[i]?.()
      })
    }

    const list = updateRefs.current.dependencies[getNames(name).join('.')]

    if (Array.isArray(list)) {
      list.forEach((i) => {
        compsRefs?.current?.[i]?.()
      })
    }
  }

  /** 根据默认数值自动生成dataLevel */
  useEffect(() => {
    let dataSource = initialValues
    const attrs = getNames(name)
    const key: string = Array.isArray(name) ? name?.[0] : name

    for (const key of attrs) {
      dataSource = dataSource?.[key] || [{}]
    }

    if (Array.isArray(dataSource)) {
      const _level = dataSource.map((i, index) => {
        return {
          key: index,
          name: `${attrs.join('.')}.${index}`,
        }
      })
      setDataLevel(_level)
      maxRef.current = dataSource.length - 1
      if (form) {
        form.dataLevel[key] = _level
      }
      updateRender()
    }
  }, [form, initialValues, name])

  /** 新增一列 */
  const handleAdd: TAddOrRemove = (index) => {
    const tempDataLevel = cloneDeep(dataLevel)
    const key: string = Array.isArray(name) ? name?.[0] : name
    maxRef.current++
    const attrs = getNames(name)
    tempDataLevel.splice(index + 1, 0, {
      key: maxRef.current,
      name: `${attrs?.join('.')}.${maxRef.current}`,
    })
    setDataLevel(tempDataLevel)
    if (form) {
      form.dataLevel[key] = tempDataLevel
    }
    updateRender()
  }

  /** 删除一列 */
  const handleDel: TAddOrRemove = (index) => {
    const temp = cloneDeep(dataLevel)
    const key: string = Array.isArray(name) ? name?.[0] : name
    temp.splice(index, 1)
    setDataLevel(temp)
    if (form) {
      form.dataLevel[key] = temp
    }
    updateRender()
  }

  return <>{children?.(dataLevel, { add: handleAdd, remove: handleDel })}</>
}

// name 没有改变就不需要重复render
export default memo(List, (nextProps, prevProps) => {
  if (isEqual(nextProps.name, prevProps.name) && !!prevProps.name) {
    return true
  }
  return false
})
